import { ReactElement } from 'react';
import cn from 'classnames';

import styles from './SmileyInput.module.scss';
import { Icon } from '../Icon/Icon';
import { FieldInputProps } from 'formik';
import { getDataTest } from '../../utils/dataTests';

interface SmileyInputProps {
    id: 'good' | 'neutral' | 'bad';
    className?: string;
    field: FieldInputProps<string | number>;
    value: string;
}

export const SmileyInput = ({ className, id, field, ...props }: SmileyInputProps): ReactElement | null => {
    return (
        <div className={cn(styles.wrapper, className)} {...props}>
            <input
                id={id}
                type="radio"
                className={styles.checkbox}
                {...field}
                data-test={getDataTest(props, 'Input')}
            />
            <label className={cn(styles.label, styles[id])} htmlFor={id} data-test={getDataTest(props, 'Label')}>
                <Icon className={styles.icon} name={id} data-test={getDataTest(props, 'Icon')} />
            </label>
        </div>
    );
};
